import { Injectable } from "@angular/core";
import { FormGroup, UntypedFormArray } from "@angular/forms";
import { TypZaznamuTextu } from "./model/typ-zaznamu-textu";

@Injectable({
  providedIn: 'root'
})


export class FormService {

  // indexDruhejPolozky - index druhej polozky z tych dvoch poloziek, ktore medzi sebou vymienam
    vymenPolozky(formularFormGroup: FormGroup, typZaznamuTextu: TypZaznamuTextu,
      indexDruhejPolozky: number, kodJazyk: string) {

      const nameControls =  'name_'+ typZaznamuTextu.id + '_' + kodJazyk;
      const formArray = <UntypedFormArray>formularFormGroup.get(nameControls);
      let textPolozky1 = formArray.value[indexDruhejPolozky-1];
      let textPolozky2 = formArray.value[indexDruhejPolozky];

      let control1 = formArray.get((indexDruhejPolozky - 1).toString());
      let control2 = formArray.get((indexDruhejPolozky).toString());

      control1.patchValue(textPolozky2);
      control2.patchValue(textPolozky1);

    }


}



